import React, { useState, useEffect } from "react";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import { API, graphqlOperation } from "aws-amplify";
import Snackbar from "../Snackbar/Snackbar";
import { useHistory } from "react-router";
import { campaignData } from "../../store/action";
import { listProductTables, productById } from "../../graphql/queries";
import { useTranslation } from "react-i18next";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import cardimg from "../../assets/visa_PNG2.png";
import Button from "../Button/Button";
import {
  createCardInfo,
  updateCardInfo,
  createPayment,
} from "../../graphql/mutations";
import { listCardInfos } from "../../graphql/queries";
import Visa from "../../assets/visa.png";
import Mastercard from "../../assets/mastercard.png";
const CARD_OPTIONS = {
  iconStyle: "solid",
  style: {
    base: {
      iconColor: "#c4f0ff",
      color: "#000",
      fontWeight: 500,
      fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
      fontSize: "16px",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": {
        color: "#000",
      },
      "::placeholder": {
        color: "gray",
      },
      height: "30px",
    },
    invalid: {
      iconColor: "red",
      color: "red",
    },
  },
};

const CardField = ({ onChange, tprice }) => (
  <div className="FormRow">
    <CardElement options={CARD_OPTIONS} onChange={onChange} amount={tprice} />
  </div>
);

const Field = ({
  label,
  id,
  type,
  placeholder,
  required,
  autoComplete,
  value,
  onChange,
  notregion,
}) => (
  <div className="Form-Row">
    <label htmlFor={id} className="FormRow-Label">
      {label}
      {notregion ? null : <span>*</span>}
    </label>
    <br />
    <input
      className="FormRow-Input"
      id={id}
      type={type}
      placeholder={placeholder}
      required={required}
      autoComplete={autoComplete}
      value={value}
      onChange={onChange}
    />
  </div>
);

const SubmitButton = ({ processing, error, children, disabled }) => (
  <button
    className={`SubmitButton ${error ? "SubmitButton--error" : ""}`}
    type="submit"
    disabled={processing || disabled}
  >
    {processing ? "Processing..." : children}
  </button>
);

const ErrorMessage = ({ children }) => (
  <div className="ErrorMessage" role="alert">
    <svg width="16" height="16" viewBox="0 0 17 17">
      <path
        fill="#FFF"
        d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
      />
      <path
        fill="#6772e5"
        d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
      />
    </svg>
    {children}
  </div>
);

const CheckoutForm = ({ tprice, total }) => {
  const stripe = useStripe();
  const elements = useElements();
  const history = useHistory();
  const [error, setError] = useState(null);
  const [cardComplete, setCardComplete] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [msg, setmsg] = useState("");
  const [errMsg, seterrMsg] = useState("");
  const campaign = useSelector((state) => state.campaign.campaign);
  const getId = localStorage.getItem("email");
  const { t } = useTranslation();
  const [billingDetails, setBillingDetails] = useState({
    email: "",
    phone: "",
    name: "",
    del_add: "",
    city: "",
    region: "",
    postal_code: "",
    country: "",
    card: false,
  });
  const [userData, setuserData] = useState([]);
  const [customerData, setcustomerData] = useState([]);
  const [savedcard, setsavedcard] = useState(false);
  const [changecard, setchangecard] = useState(false);
  const [updateCard, setupdateCard] = useState(false);
  const [shipping, setShipping] = useState(0);
  const [orderProd, setorderprod] = useState([]);
  const [desc, setDesc] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    getCards(getId);
  }, []);

  const getCards = async (getId) => {
    try {
      const productImages = await API.graphql(
        graphqlOperation(listCardInfos, {
          filter: {
            userId: {
              eq: getId,
            },
          },
        })
      );
      setuserData(productImages.data.listCardInfos.items[0]);
      if (productImages) {
        API.post("laetusapi", "/api/v1/stripepayment", {
          body: {
            type: "getcustomer",
            customerId: productImages.data.listCardInfos.items[0].customerId,
            cardId: productImages.data.listCardInfos.items[0].cardId,
          },
        })
          .then((res) => {
            setcustomerData(res);
          })
          .catch((err) => {
            seterrMsg(err.message, "error");
            setTimeout(() => {
              seterrMsg("");
            }, 1500);
          });
      }
    } catch (error) {
      return error;
    }
  };
  useEffect(() => {
    if (customerData.customer) {
      setsavedcard(true);
    }
  }, [customerData]);

  useEffect(() => {
    if (userData) {
      setBillingDetails({
        ...billingDetails,
        email: userData.email,
        phone: userData.phoneNo,
        name: userData.userName,
        del_add: "",
        city: userData.city,
        region: userData.region,
        postal_code: userData.postalCode,
        country: userData.country,
        del_add: userData.address,
      });
    }
  }, [userData]);

  const getProducts = async (getId) => {
    let nextToken = null;
    let items = [];
    try {
      do {
        const productImages = await API.graphql(
          graphqlOperation(productById, {
            customerId: getId,
            nextToken,
            limit: 100,
          })
        );
        items = items.concat(
          productImages.data.productById.items.sort(
            (a, b) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          )
        );
        nextToken = productImages.data.productById.nextToken;
      } while (nextToken);
      dispatch(
        campaignData({
          campaign: items,
        })
      );
    } catch (error) {
      return error;
    }
  };
  // const total = campaign
  // 	.map((data) =>
  // 		data.colors && data.size
  // 			? data.colors && data.size
  // 				? Number(data.quantity) * Number(data.realprice)
  // 				: null
  // 			: null,
  // 	)
  // 	.reduce((x, y) => x + y);
  useEffect(() => {
    let concat = "PrototypeApp ";
    orderProd?.map(
      (itm) =>
        (concat += `${
          itm.shirtName +
          ` (${itm.shirtName + "-" + itm.size})` +
          " X " +
          itm.quantity +
          " = " +
          itm.quantity * itm.price +
          " € " +
          " ~~ "
        }`)
    );
    concat += `${
      ` Shipping: ` +
      shipping +
      " € " +
      ` Taxes: ` +
      ((total + shipping + 3.5) / 6).toFixed(2) +
      " € " +
      " ~~ " +
      " Total: " +
      (total + shipping + 3.5)
    }`;
    setDesc(concat);
  }, [orderProd]);

  useEffect(() => {
    if (total === 0) {
      history.goBack();
    }
  }, [total]);

  useEffect(() => {
    const ship = [];
    if (campaign) {
      campaign.map((data) => {
        data.colors && data.size && ship.push(Number(data.quantity * 1.5));
        data?.variation?.length > 0 &&
          data.variation.map((variant) => {
            variant.colors &&
              variant.size &&
              ship.push(Number(variant.quantity) * 1.5);
          });
      });
      if (ship.length > 0) {
        setShipping(ship.map((data) => data)?.reduce((x, y) => x + y));
      }
    }
  }, [campaign]);

  useEffect(() => {
    const ship = [];
    if (campaign) {
      campaign.map((data) =>
        data.colors && data.size
          ? data.colors && data.size
            ? ship.push({
                campaignId: data.id,
                quantity: data.quantity,
                size: data.size,
                shirtName: data.shirtName,
                designShirt: data.designShirt,
                price: data.realprice,
                colors: data.colors,
              })
            : null
          : null
      );
    }
    setorderprod(ship);
  }, [campaign]);

  const payments = () => {
    API.graphql(
      graphqlOperation(createPayment, {
        input: {
          total: total,
          subTotal: (total + shipping + 3.5).toString(),
          shipCharge: (shipping + 3.5).toString(),
          items: orderProd,
          customerId: getId,
        },
      })
    )
      .then((res) => {
        setmsg("Data save");
        setTimeout(() => {
          setmsg("");
        }, 1500);
      })
      .catch((err) => {
        seterrMsg(err.message);
        setTimeout(() => {
          seterrMsg("");
        }, 1500);
      });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setmsg("");
    seterrMsg("");
    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    if (!savedcard) {
      if (error) {
        elements.getElement("card").focus();
        return;
      }
      if (cardComplete) {
        setProcessing(true);
      }
      const payload = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement(CardElement),
        billing_details: {
          name: billingDetails.name,
          email: billingDetails.email,
          phone: billingDetails.phone,
        },
      });

      if (payload.error) {
        setError(payload.error);
      } else {
        if (
          (!billingDetails.card && !updateCard) ||
          (changecard && !updateCard)
        ) {
          API.post("laetusapi", "/api/v1/stripepayment", {
            body: {
              amount: total + shipping + 3.5,
              id: payload.paymentMethod.id,
              cardsafe: false,
              type: "card",
              phone: billingDetails.phone,
              name: billingDetails.name,
              city: billingDetails.city,
              country: billingDetails.country,
              postalCode: billingDetails.postal_code,
              region: billingDetails.region,
              addresLine: billingDetails.del_add,
              desc: desc,
            },
          })
            .then((res) => {
              payments();
              setProcessing(false);
              // setmsg(res);
              history.push("/confirmPay");
              // setTimeout(() => {
              // 	setmsg("");
              // }, 1500);
              setBillingDetails({
                email: "",
                phone: "",
                name: "",
              });
              getProducts(getId);
            })
            .catch((err) => {
              seterrMsg(err.message);
              setProcessing(false);
              setTimeout(() => {
                seterrMsg("");
              }, 1500);
            });
        } else if (billingDetails.card) {
          API.post("laetusapi", "/api/v1/stripepayment", {
            body: {
              amount: total + shipping + 3.5,
              id: payload.paymentMethod.id,
              email: billingDetails.email,
              cardsafe: true,
              type: "card",
              source: payload.paymentMethod.card.brand,
              phone: billingDetails.phone,
              name: billingDetails.name,
              city: billingDetails.city,
              country: billingDetails.country,
              postalCode: billingDetails.postal_code,
              region: billingDetails.region,
              addresLine: billingDetails.del_add,
              desc: desc,
            },
          })
            .then(async (res) => {
              payments();
              API.graphql(
                graphqlOperation(createCardInfo, {
                  input: {
                    userId: getId,
                    userName: billingDetails.name,
                    email: billingDetails.email,
                    city: billingDetails.city,
                    region: billingDetails.region,
                    postalCode: billingDetails.postal_code,
                    country: billingDetails.country,
                    phoneNo: billingDetails.phone,
                    cardNum: billingDetails.card,
                    address: billingDetails.del_add,
                    customerId: res.customer,
                    cardId: res.id,
                  },
                })
              )
                .then((res) => {
                  setProcessing(false);
                  setmsg("Votre paymnet payé avec succès");
                  // setmsg(res);
                  history.push("/confirmPay");
                  // setTimeout(() => {
                  // 	setmsg("");
                  // }, 1500);
                  setBillingDetails({
                    email: "",
                    phone: "",
                    name: "",
                  });
                  getProducts(getId);
                })
                .catch((err) => {
                  setProcessing(false);
                  seterrMsg(err.message);
                  setTimeout(() => {
                    seterrMsg("");
                  }, 1500);
                });
            })
            .catch((err) => {
              setProcessing(false);
              seterrMsg(err.message);
              setTimeout(() => {
                seterrMsg("");
              }, 1500);
            });
        } else if (updateCard) {
          API.post("laetusapi", "/api/v1/stripepayment", {
            body: {
              amount: total + shipping + 3.5,
              id: payload.paymentMethod.id,
              email: billingDetails.email,
              type: "update",
              source: payload.paymentMethod.card.brand,
              cardId: userData.cardId,
              customerId: customerData.customer,
              phone: billingDetails.phone,
              name: billingDetails.name,
              city: billingDetails.city,
              country: billingDetails.country,
              postalCode: billingDetails.postal_code,
              region: billingDetails.region,
              addresLine: billingDetails.del_add,
            },
          })
            .then((res) => {
              payments();
              API.graphql(
                graphqlOperation(updateCardInfo, {
                  input: {
                    id: userData.id,
                    userId: getId,
                    userName: billingDetails.name,
                    email: billingDetails.email,
                    city: billingDetails.city,
                    region: billingDetails.region,
                    postalCode: billingDetails.postal_code,
                    country: billingDetails.country,
                    phone: billingDetails.phone,
                    cardNum: billingDetails.card,
                    address: billingDetails.del_add,
                    customerId: res.customer,
                    cardId: res.id,
                  },
                })
              )
                .then((res) => {
                  setProcessing(false);
                  setmsg("Votre paymnet payé avec succès");
                  // setmsg(res);
                  history.push("/confirmPay");
                  // setTimeout(() => {
                  // 	setmsg("");
                  // }, 1500);
                  setBillingDetails({
                    email: "",
                    phone: "",
                    name: "",
                  });
                  getProducts(getId);
                })
                .catch((err) => {
                  setProcessing(false);
                  seterrMsg(err.message);
                  setTimeout(() => {
                    seterrMsg("");
                  }, 1500);
                });
            })
            .catch((err) => {
              setProcessing(false);
              seterrMsg(err.message);
              setTimeout(() => {
                seterrMsg("");
              }, 1500);
            });
        }
      }
    } else {
      setmsg("");
      seterrMsg("");
      setProcessing(true);
      API.post("laetusapi", "/api/v1/stripepayment", {
        body: {
          amount: total + shipping + 3.5,
          customerId: customerData.customer,
          phone: billingDetails.phone,
          name: billingDetails.name,
          city: billingDetails.city,
          country: billingDetails.country,
          postalCode: billingDetails.postal_code,
          region: billingDetails.region,
          addresLine: billingDetails.del_add,
          desc: desc,
          type: "saveCard",
        },
      })
        .then((res) => {
          payments();
          setProcessing(false);
          setmsg("Votre paymnet payé avec succès");
          getProducts(getId);
          // setmsg(res);
          history.push("/confirmPay");
          // setTimeout(() => {
          // 	setmsg("");
          // }, 1500);
        })
        .catch((err) => {
          setProcessing(false);
          seterrMsg(err.message);
          setTimeout(() => {
            seterrMsg("");
          }, 1500);
        });
    }
  };

  return (
    <div className="stripe">
      <form onSubmit={handleSubmit}>
        <div className="strip-form">
          <div className="left-side">
            <div className="inp-div">
              <h3>Information Client</h3>
              <hr />
              <Field
                label="Email"
                id="email"
                type="email"
                required
                autoComplete="email"
                value={billingDetails.email}
                onChange={(e) => {
                  setBillingDetails({
                    ...billingDetails,
                    email: e.target.value,
                  });
                }}
              />
            </div>
            <div className="inp-div">
              <h3>{t("delivery-info")}</h3>
              <hr />
              <Field
                label={t("full-name")}
                id="name"
                type="text"
                required
                autoComplete="name"
                value={billingDetails.name}
                onChange={(e) => {
                  setBillingDetails({
                    ...billingDetails,
                    name: e.target.value,
                  });
                }}
              />
              <Field
                label={t("del-add")}
                id="address"
                type="text"
                required
                autoComplete="address"
                value={billingDetails.del_add}
                onChange={(e) => {
                  setBillingDetails({
                    ...billingDetails,
                    del_add: e.target.value,
                  });
                }}
              />
              <div className="address">
                <div className="add-inp">
                  <Field
                    label={t("city")}
                    id="city"
                    type="text"
                    required
                    autoComplete="city"
                    value={billingDetails.city}
                    onChange={(e) => {
                      setBillingDetails({
                        ...billingDetails,
                        city: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="add-inp">
                  <Field
                    label="Region (Optionnel)"
                    id="region"
                    type="text"
                    autoComplete="region"
                    value={billingDetails.region}
                    onChange={(e) => {
                      setBillingDetails({
                        ...billingDetails,
                        region: e.target.value,
                      });
                    }}
                    notregion
                  />
                </div>
                <div className="add-inp">
                  <Field
                    label={t("postal")}
                    id="postal-code"
                    type="text"
                    required
                    autoComplete="postal-code"
                    value={billingDetails.postal_code}
                    onChange={(e) => {
                      setBillingDetails({
                        ...billingDetails,
                        postal_code: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <Field
                label={t("country")}
                id="country"
                type="text"
                required
                autoComplete="country"
                value={billingDetails.country}
                onChange={(e) => {
                  setBillingDetails({
                    ...billingDetails,
                    country: e.target.value,
                  });
                }}
              />
              <Field
                label={t("phone")}
                id="phone"
                type="text"
                required
                autoComplete="phone"
                value={billingDetails.phone}
                onChange={(e) => {
                  setBillingDetails({
                    ...billingDetails,
                    phone: e.target.value,
                  });
                }}
              />
            </div>
            <div className="inp-div">
              <h3>
                <LockOutlinedIcon style={{ color: "gray" }} /> Information
                Client
              </h3>
              <hr />
              <div className="address card-div">
                <div>
                  <input
                    type="radio"
                    id="html"
                    name="fav_language"
                    value="HTML"
                  />
                  <label for="html" style={{ fontWeight: "400" }}>
                    {t("card")}
                  </label>
                </div>
                <div>
                  <img src={cardimg} alt="cards" width={150} />
                </div>
              </div>
              {customerData.customer ? (
                <>
                  <div className="paymentmethod">
                    <div
                      style={{
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <img
                        src={
                          customerData.brand === "Visa"
                            ? Visa
                            : customerData.brand === "MasterCard"
                            ? Mastercard
                            : null
                        }
                        alt="card"
                        width={35}
                        height={30}
                      />
                      <span style={{ marginLeft: "10px" }}>
                        **** {customerData.last4}
                      </span>
                    </div>
                    <div className="checkbox">
                      <input
                        type="checkbox"
                        id="vehicle1"
                        checked={savedcard ? true : false}
                        value={savedcard}
                        className="check"
                        onChange={() => {
                          setsavedcard((prev) => !prev);
                          setchangecard(changecard && false);
                        }}
                      />
                    </div>
                  </div>
                  <div className="paymentmethod">
                    <div
                      style={{
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <span>{t("card")}</span>
                    </div>
                    <div className="checkbox">
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                        checked={changecard && !savedcard ? true : false}
                        value={changecard}
                        className="check"
                        onChange={() => {
                          setchangecard((prev) => !prev);
                          setsavedcard(savedcard && false);
                        }}
                      />
                    </div>
                  </div>
                  {changecard && (
                    <fieldset className="FormGroup">
                      <CardField
                        onChange={(e) => {
                          setError(e.error);
                          setCardComplete(e.complete);
                        }}
                        tprice={total + shipping + 3.5}
                      />
                    </fieldset>
                  )}
                </>
              ) : (
                <fieldset className="FormGroup">
                  <CardField
                    onChange={(e) => {
                      setError(e.error);
                      setCardComplete(e.complete);
                    }}
                    tprice={tprice}
                  />
                </fieldset>
              )}
              {error && <ErrorMessage>{error.message}</ErrorMessage>}
              {customerData.length < 1 ? (
                <>
                  <input
                    type="checkbox"
                    id="vehicle1"
                    name="vehicle1"
                    value={billingDetails.card}
                    className="check"
                    onChange={(e) => {
                      setBillingDetails((prev) => ({
                        ...prev,
                        card: prev.card ? false : true,
                      }));
                    }}
                  />
                  <label for="vehicle1">
                    <span>{t("save-card")}</span>
                  </label>
                  <br></br>
                </>
              ) : (
                <>
                  {/* <input
										type="checkbox"
										id="vehicle1"
										name="vehicle1"
										value={updateCard}
										className="check"
										onChange={() => {
											setupdateCard((prev) => !prev);
										}}
									/>
									<label for="vehicle1">
										<span>{t("upd-card")}</span>
									</label>
									<br></br> */}
                </>
              )}
            </div>
            <div className="sub-btn">
              <Button
                text={t("ord")}
                style={{ width: "70%", textAlign: "center" }}
                loader={processing}
              />
            </div>
          </div>
          <div className="right-side">
            <div
              style={{
                height: "385px",
                overflow: "auto",
                marginBottom: "40px",
              }}
            >
              {campaign.map((data, ind) => {
                return data.quantity > 0 && data.colors && data.size ? (
                  <div className="inp-div">
                    <h3>{t("order-sum")}</h3>
                    <hr />
                    <div className="shirt-div">
                      <div className="shirt">
                        <div>
                          <img
                            src={data.designShirt || data.designnimg}
                            alt="shirt"
                            width={80}
                            height={100}
                          />
                        </div>
                        <div className="shirt-para">
                          <p>
                            <b>{data.shirtName || data.shirtname}</b>
                          </p>
                          <p className="para">
                            {t("quantity")}:{data.quantity}
                          </p>
                          <p>
                            {t("size")}:{data.size}
                          </p>
                        </div>
                      </div>
                      <div>
                        <p>
                          {Number(data.quantity) * Number(data.realprice)} €
                        </p>
                      </div>
                    </div>
                    {data?.variation?.length &&
                      data.variation.map((variant) => {
                        return (
                          variant.quantity > 0 &&
                          variant.colors &&
                          variant.size && (
                            <div className="shirt-div">
                              <div className="shirt">
                                <div>
                                  <img
                                    src={
                                      variant.designShirt || variant.designnimg
                                    }
                                    alt="shirt"
                                    width={80}
                                    height={100}
                                  />
                                </div>
                                <div className="shirt-para">
                                  <p>
                                    <b>
                                      {variant.shirtName || variant.shirtname}
                                    </b>
                                  </p>
                                  <p className="para">
                                    {t("quantity")}:{variant.quantity}
                                  </p>
                                  <p>
                                    {t("size")}:{variant.size}
                                  </p>
                                </div>
                              </div>
                              <div>
                                <p>
                                  {Number(variant.quantity) *
                                    Number(variant.realprice)}{" "}
                                  €
                                </p>
                              </div>
                            </div>
                          )
                        );
                      })}
                  </div>
                ) : null;
              })}
            </div>
            <div className="inp-div">
              <h3>{t("total")}</h3>
              <hr />
              <div className="shirt-div">
                <div className="shirt">
                  <div className="shirt-para font_size">
                    <p>{t("sub-total")}</p>
                    <p className="para">{t("del")}</p>
                    <p style={{ fontSize: "16px" }}>{t("total")}</p>
                  </div>
                </div>
                <div className="shirt-para font_size">
                  <p>{total} €</p>
                  <p className="para">{shipping + 3.5} €</p>
                  <p style={{ fontSize: "16px" }}>{total + shipping + 3.5} €</p>
                </div>
              </div>
            </div>
            <div className="sub-btn">
              <Button
                text={t("ord")}
                style={{ width: "70%", textAlign: "center" }}
                loader={processing}
              />
            </div>
          </div>
        </div>
      </form>
      {msg || errMsg ? <Snackbar message={msg} errMessage={errMsg} /> : null}
    </div>
  );
};

export default CheckoutForm;
